import React, { useEffect, useState } from "react";
import { FirebaseRef } from "../../lib/firebase";
import Loader from "../../components/Loader";

function Content(props) {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const id = props.match.params.id;
    const ref = FirebaseRef.child(`/${id}`);
    setLoading(true);
    ref.on("value", (snapshot) => {
      const data = snapshot.val() || {};
      if (data.content) {
        setContent(data.content);
      }
      setLoading(false);
    });
  }, [props]);
  return (
    <div
      style={{ marginTop: "20px", marginBottom: "20px" }}
      className="container"
    >
      <Loader show={loading} />
      <div dangerouslySetInnerHTML={{ __html: content }}></div>
    </div>
  );
}

export default Content;
